import { formatNumberWithSpaces } from "utils/numbers"

// Éléments communs aux rapports Argent (styles dans moneyReports.css)

export const formatEur = (value) => `${formatNumberWithSpaces(value)} €`

// montant en euros ; les montants nuls sont atténués pour faire ressortir les autres
export const Amount = ({ value, strong }) => Number(value)
    ? <span className={`money_report_num${strong ? ' money_report_num_strong' : ''}`}>{formatEur(value)}</span>
    : <span className="money_report_num money_report_num_zero">—</span>

export const Count = ({ value }) => <span className="money_report_num">{formatNumberWithSpaces(value ?? 0)}</span>

export const ReportHeader = ({ title, hint }) => (
    <>
        <div className="money_report_title_row">
            <h1 className="money_report_page_title">{title}</h1>
        </div>
        {hint && <p className="money_report_hint">{hint}</p>}
    </>
)

// tiles : [{ label, value, hint, main }]
export const SummaryTiles = ({ tiles }) => (
    <section className="money_report_summary" aria-label="Totaux sur la période">
        {tiles.map(tile => (
            <div key={tile.label} className={`money_report_tile${tile.main ? ' money_report_tile_main' : ''}`}>
                <p className="money_report_tile_label">{tile.label}</p>
                <p className="money_report_tile_value">{tile.value}</p>
                {tile.hint && <p className="money_report_tile_hint">{tile.hint}</p>}
            </div>
        ))}
    </section>
)

export const Pager = ({ page, setPage, hasNextPage }) => (page > 0 || hasNextPage) && (
    <nav className="money_report_pager" aria-label="Pagination">
        <button className="money_report_secondary_button" disabled={page === 0} onClick={() => setPage(page - 1)}>Précédent</button>
        <span className="money_report_num" aria-live="polite">Page {page + 1}</span>
        <button className="money_report_secondary_button" disabled={!hasNextPage} onClick={() => setPage(page + 1)}>Suivant</button>
    </nav>
)

export const EmptyState = ({ title, hint }) => (
    <div className="money_report_empty">
        <p className="money_report_empty_title">{title}</p>
        {hint && <p className="money_report_empty_hint">{hint}</p>}
    </div>
)

export const ErrorState = ({ title, onRetry }) => (
    <div className="money_report_card">
        <div className="money_report_empty money_report_empty_error" role="alert">
            <p className="money_report_empty_title">{title}</p>
            <button className="money_report_secondary_button" onClick={onRetry}>Réessayer</button>
        </div>
    </div>
)
